import { getCookie } from '@/pkg/cookie'
import axios from 'axios'

let smsClient
const token = getCookie('resource')

if (process.env.NODE_ENV === 'development') {
  smsClient = axios.create({
    baseURL: process.env.VUE_APP_API_SMS_URL,
    headers: { Authorization: `Bearer ${token}` },
  })
} else {
  smsClient = axios.create({
    baseURL: process.env.VUE_APP_API_SMS_URL,
    withCredentials: true,
  })
}

export function getSmsClient() {
  return smsClient
}
